import axios from 'axios';
import { getDataOptions, postDataOptions } from '../services/backendServices';
import { BASE_URL, COMMONS_SERVICE_BASE_URL } from './environments';

// Api's
const PROFILE_API = 'auth/getProfileDetails';
const DETAILS_WITH_COUNT_API = 'api/m/user/detailsWithCount';
const PROFILE_UPDATE_API = 'api/user/v2/updateProfile';
const PROFILE_PICTURE_API = 'api/m/user/profilePicture';
const MCI_UPLOAD_API = 'api/m/user/medicalCertificate';
const GET_INFO_FROM_ZIP_CODE = '/api/login/getInfoFromZip';
const CONFIRMATION_EMAIL_API = 'api/m/user/resendConfirmationEmail/';
const VERIFY_EMAIL_API = 'api/login/confirm?token={tokenId}';
const PLATFORM_REVIEW_API = 'api/user/platform/review';
const TIME_TRACKER_API = 'api/user/userProductWiseTimeTracker';
const PLATFORM_REVIEWED_API = 'api/user/platform/isReviewed?platform=WEB';
const UPDATE_MCI_COUNTRY_API = 'api/m/user/updateMCICountry?mciCountryId=';

// Services
export const getProfileService = async () => {
  try {
    const response = await axios(postDataOptions(COMMONS_SERVICE_BASE_URL, PROFILE_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const detailsWithCountService = async () => {
  try {
    const response = await axios(postDataOptions(COMMONS_SERVICE_BASE_URL, PROFILE_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const profileUpdateService = async (data) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, PROFILE_UPDATE_API, data));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const profilePictureUpdateService = async (data) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, PROFILE_PICTURE_API, data));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const UploadMCIService = async (data) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, MCI_UPLOAD_API, data));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const cityForZipCodeService = async (data) => {
  try {
    const response = await axios(getDataOptions(BASE_URL, GET_INFO_FROM_ZIP_CODE + '?countryCode=' + data.countryCode + '&zipCode=' + data.zipCode));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const confirmationEmailService = async (email, organizationId) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, CONFIRMATION_EMAIL_API + email + `?isMicroSite=true&organizationId=${organizationId}`));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fetchWalletAmountService = async (data) => {
  try {
    const response = await axios(postDataOptions('https://pumastgapifinal.omnicuris.com/user/wallet'), {}, true);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const verifyEmail = async (token) => {
  try {
    const data = {
      token: token,
    };
    const url = VERIFY_EMAIL_API.replace('{tokenId}', token);
    const response = await axios(postDataOptions(BASE_URL, url, data));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const sendPlatformReview = async (data) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, PLATFORM_REVIEW_API, data));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const userProductWiseTimeTrackerService = async (payload) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, TIME_TRACKER_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkPlatformIsReviewed = async () => {
  const accessToken = JSON.parse(localStorage.getItem('userAccessToken'));
  try {
    const response = await axios({
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'hk-access-token': accessToken,
      },
      data: {},
      url: BASE_URL + PLATFORM_REVIEWED_API,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateMciCountryService = async (id) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, UPDATE_MCI_COUNTRY_API + id));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
